import { render, staticRenderFns } from "./AiBookDownloadUrlConfig.vue?vue&type=template&id=41f44d4a&scoped=true"
import script from "./AiBookDownloadUrlConfig.vue?vue&type=script&lang=js"
export * from "./AiBookDownloadUrlConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f44d4a",
  null
  
)

export default component.exports